import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';

interface AccordionHeaderProps {
  title: string;
  result: string;
  details?: string;
}

const AccordionHeader = ({ title, result, details }: AccordionHeaderProps) => {
  return (
    <div className="tag-accordion-header">
      <Typography variant="body-7" fontWeight="bold">
        {title}
      </Typography>

      <Typography variant="body-7" fontWeight="semibold" className="caps" color={result === 'passed' ? '#70DA74' : '#D9534F'}>
        {i18n(`tag.validation.result.${result}`)}
      </Typography>

      {details && (
        <Typography variant="body-5" fontWeight="semibold" color={details.includes('error') ? '#D9534F' : details.includes('warning') ? '#F0AD4E' : undefined}>
          {details}
        </Typography>
      )}
    </div>
  );
};

export { AccordionHeader };
